import React from 'react'
import game_overview_thumb from "../Assets/Images/images/game_overview_thumb.png";
import { useNavigate } from 'react-router-dom';

const MostPlayed = () => {

    const navigate = useNavigate();

    const handleBtn=()=>{
        navigate(`/Category/mostPlayed`)
    }

  return (
    <div className=" breadcrumb-bg p-0 mt-0">
    <div className="p-4">
      <div className="flex items-center justify-center flex-col gap-2 w-full sm:flex-row">
        
          <div className="flex items-center h-full">
            <img
              src={game_overview_thumb}
              // src="img/images/game_overview_thumb.png"
              alt=""
            />
          </div>
        
        
          <div className=" text-center text-left w-[100%] md:w-[50%] ">
            <h2 className='w-full text-5xl w-[100%] md:text-7xl'>
              Most Played Games <span>{new Date().getFullYear()}</span>
            </h2>
            
            <span onClick={handleBtn} className="btn btn-style-two">
              Try Most Played...
            </span>
          </div>
        
      </div>
    </div>
  </div>
  )
}

export default MostPlayed
